import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {filterNodeProperties} from '../../../../utilities/filter-node-properties';
import {decimaltoHex, RGBFormatFromDecimal} from '../../../../utilities/common';
import {isEmpty} from '../../../../utilities/validation';
import {parseStudentAnswer} from '../../../../utilities/xml';

const getDataFromNode = function (node) {
    const keys = ['id', 'title', 'text_align', 'border_style', 'x', 'y', 'answer', 'variable',
        'prompt_highlight_color', 'correct_highlight_color', 'final_highlight_color', 'bgcolor', 'bgalpha',
        'height', 'width', 'zIndex'];
    return filterNodeProperties(node, keys);
};

class RangeField extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...getDataFromNode(props.node)
        };
    }

    getColorBasedOnAnswerStatus(answerStatus) {
        const {prompt_highlight_color = 0, correct_highlight_color = 0, final_highlight_color = 0} = this.state;

        if (answerStatus === 'final') {
            return `#${decimaltoHex(final_highlight_color)}`;
        } else if (answerStatus === 'prompt') {
            return `#${decimaltoHex(prompt_highlight_color)}`;
        } else if (answerStatus === 'correct') {
            return `#${decimaltoHex(correct_highlight_color)}`;
        } else {
            return null;
        }
    }

    render() {
        let {width = 0, y = 0, x = 0, height = 0, id = 0, text_align = 'center',
            border_style = 'solid', bgcolor, bgalpha ='', zIndex, value='', variable = ''} = this.state;
        const {answer = '', answerStatus = '', fontcolor, studentAnswers={}} = this.props;
        const borderColor = this.getColorBasedOnAnswerStatus(answerStatus);

        if(!isEmpty(studentAnswers) && !isEmpty(variable)) {
            value = parseStudentAnswer(studentAnswers, variable);
        }
        x = x - 5;
        const divStyle = {
            top: `${y}px`,
            left: `${x}px`,
            zIndex: !isEmpty(zIndex) ? zIndex : 1,
            color: (fontcolor ? `#${decimaltoHex(fontcolor)}` : 'inherit'),
        };
        if(height > 0) {
            height = `${height}px`;
        }
        else {
            height = '100%';
        }
        if(width > 0) {
            width = `${width}px`;
        }
        else {
            width = '100%';
        }
        const inputStyle = {
            textAlign: text_align,
            height: height,
            width:  width,
            borderStyle: border_style,
            borderColor: (borderColor) ? borderColor : 'transparent',
            backgroundColor: !isEmpty(bgcolor) ? RGBFormatFromDecimal(bgcolor, bgalpha) : 'transparent',
        };

        if(!isEmpty(answer)){
            value = answer;
        }
        return (
            <div className="node range-field" style={divStyle}>
                <input style={inputStyle} type="text" name={id} value={value} onChange={this.props.onChange}/>
            </div>
        );
    }
}

RangeField.propTypes = {
    node: PropTypes.object.isRequired,
    answerStatus: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        studentAnswers: state.answers.list
    };
};

const RangeFieldNode = connect(
    mapStateToProps,
    null
)(RangeField);

export default RangeFieldNode;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/range-field-node.js